// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/sitzwannenverstaerkung-lordosenstuetze/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteSitzwannenverstaerkungLordosenstuetzeDE: PageEntry = {
  id: "example.produkte-sitzwannenverstaerkung-lordosenstuetze",
  locale: "de",
  slug: "produkte/sitzwannenverstaerkung-lordosenstuetze",
  seo: {
    title: "Sitzwannenverstärkung, Lordosenstütze | Dietz GmbH",
    description: "… verbaut in der Sitzwanne im PKW Um die Stabilität der Fahrzeugsitze sicherzustellen kommen diese Bauteile zum Einsatz, weiterhin wurden durch die Kombination von Metall und Kunst",
  },
  type: "post",
  h1: "Sitzwannenverstärkung, Lordosenstütze",
  intro: "… verbaut in der Sitzwanne im PKW Um die Stabilität der Fahrzeugsitze sicherzustellen kommen diese Bauteile zum Einsatz, weiterhin wurden durch die Kombination von Metall und Kunststoff optimale Teilegewichte erreicht.",
  blocks: [
    { kind: "image", src: "/images/live/dtz-sitzwanneLordosenst.jpg", alt: "Lordosenstütze - Automotive", width: 1400, height: 1120 }
  ],
};
